module.exports = __webpack_public_path__ + "img/notification.8ddcc76d.svg";